import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const SearchIcon = ({ size = 18, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-4.3-4.3" />
  </svg>
)
